export default __webpack_public_path__ + "static/media/filter_item_colour.adae714f.svg";